import * as React from "react";
import { AppUtils } from "source/framework/appUtils";
import { userParameterCodeShowDocumentPreview } from "source/models/common/webConsts";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IListFilterItem, ListFilterItem } from "../../../models/common/listFilterItem";
import { ISavedListFilter } from "../../../models/common/savedListFilter";
import { ITypedOption } from "../../../models/common/typedOption";
import { recordLockManager } from "../../../models/services/recordLockService";
import * as appReportService from "../../../models/services/appReportService";
import * as userService from "../../../models/services/userService";
import { IAppSessionState } from "../../../models/store/storeTypes";
import { HeaderMenuItem, NavigationMenu } from "../../app/NavigationMenu";
import { UserMenu } from "../../app/UserMenu";
import { ListFilterSaveDialog } from "../../framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "../../framework/Page/PageContainer";
import { PageContent } from "../../framework/Page/PageContent";
import { PageListAndReportsContainer } from "../../framework/Page/PageListAndReportsContainer";
import { PageTopBar } from "../../framework/Page/PageTopBar";
import { IPageNavMenuItem } from "../../framework/PageNav/PageNavMenuItems";
import { abortManager } from "source/models/services/tokenService";
import { RouteComponentProps } from "react-router-dom";
import { AppReportStateIdFilterActive, AppReportStateIdFilterArchived, AppReportStateIdFilterdDraft, AppReportStateIdFilterdPublished, getAppReportPageGeneralFilterFromFilterState, getFilterStateFromAppReportPageGeneralFilter, IAppReportPageFilterState } from "./AppReportPageUtils";
import { AppReportPageFilterDrawer } from "./AppReportPageFilterDrawer";
import { AppReportSettingsDialog, AppReportSettingsDialogMenuItem } from "../AppReportSettingsDialog";
import { IAppReportPage } from "source/models/appReport/appReportPage";
import { IAppReportListState, setAppReportListDefaultFilter } from "source/models/store/appReport";
import { AppReportList } from "../AppReportList/AppReportList";
import { FilterTabs } from "source/components/framework/PageNavMenuItem/FilterTabs";
import { AppReportTrashBinDialog } from "../AppReportTrashBinDialog";

// TaskPage
export interface IAppReportPageOwnProps {
}

export interface IAppReportPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    appReportPage: IAppReportPage;
    list: IAppReportListState;
}

export interface IAppReportPageDispatchProps {
    onGetAppReportPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

export interface IAppReportPagePathProps {
    page: string;
}

type AppReportPageProp = IAppReportPageOwnProps & IAppReportPageStateProps & IAppReportPageDispatchProps & RouteComponentProps<IAppReportPagePathProps>;

interface IAppReportPageState extends IAppReportPageFilterState {
    initialized: boolean;
    listDataPreloaded: boolean;
    listAddRecord: boolean;
    units: IIdTitleNode[];
    states: IIdTitle[];
    activeCompanyId: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    settingsActions: IPageNavMenuItem[];
    // Filters
    listFilterIsSet: boolean;
    showListFilter: boolean;
    listFilterFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Permissions
    dataId: number;
    canCreateAppReports: boolean;
    // Settings
    showSettingsDialog: boolean;
    // Preview
    showDocumentPreview: boolean;
    // Trash Bin
    showTrashBinDialog: boolean;
}

export class AppReportPage extends React.Component<AppReportPageProp, IAppReportPageState> {
    _isMounted: boolean;

    getUnits = (units: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        return result.concat(units);
    };
    
    getIdTitles = (idTitles: IIdTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        return result.concat(idTitles);
    };
    
    getStates = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(AppReportStateIdFilterActive, "'" + Translations.ActivePlural + "'"));
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(AppReportStateIdFilterdDraft, Translations.Draft));
        result.push(IdTitle.createIdTitle(AppReportStateIdFilterdPublished, Translations.Published));
        result.push(IdTitle.createIdTitle(AppReportStateIdFilterArchived, Translations.Archived));
        return result;
    };
    
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.Reports, Translations.Reports,
            {
                unitIds: [],
                stateIds: [AppReportStateIdFilterActive],
            }, "modifyDate", false, 0));
        result.push(ListFilterItem.createListFilterItem(Translations.Archived, Translations.Archived,
            {
                unitIds: [],
                stateIds: [AppReportStateIdFilterArchived],
            }, "modifyDate", false, 1));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getListFilterIsSet = (state: IAppReportPageState): boolean => {
        return AppReportPageFilterDrawer.filterIsSet(state, state);
    };

    getSettingsActions = (): IPageNavMenuItem[] => {
        const props = this.props;
        const sessionState = props.appState.state;
        const result: IPageNavMenuItem[] = [];
        if (props.appReportPage?.canEditAllModuleProperties) {
            result.push({ id: AppReportSettingsDialogMenuItem.Units, title: Translations.Units });
            result.push({ id: AppReportSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
        }
        if (props.appReportPage?.canCreateAppReports) {
            result.push({ id: AppReportSettingsDialogMenuItem.CompanyReportTemplates, title: Translations.ReportTemplates });
        }
        if (sessionState?.isSuperAdmin) {
            result.push({ id: Translations.SystemSettings, title: Translations.SystemSettings, divider: true });
            result.push({ id: AppReportSettingsDialogMenuItem.DefaultReportTemplates, title: Translations.DefaultReportTemplates });
        }
        return result;
    };

    constructor(props: AppReportPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filter = (props.list.defaultFilter?.filterId
            ? filters.find(i => i.id === props.list.defaultFilter.filterId)
            : filters[0]) ?? filters[0];
        const intialFilter = new ListFilterItem(filter);
        if (props.list.defaultFilter?.generalFilter) {
            intialFilter.generalFilter = { ...intialFilter.generalFilter, ...props.list.defaultFilter.generalFilter };
        }
        const filterProps = ListFilterItem.getFilterProps(intialFilter, "", true, getFilterStateFromAppReportPageGeneralFilter);
        const state = {
            ...filterProps,
            initialized: !!props.appReportPage,
            activeCompanyId: sessionState.companyId,
            listDataPreloaded: true,
            listAddRecord: false,
            units: this.getUnits(props.appReportPage?.units ?? []),
            states: this.getStates(),
            settingsActions: this.getSettingsActions(),
            // Filters
            listFilterIsSet: false,
            activeFilterId: filters[0].id,
            activeSavedFilterId: "",
            filters,
            savedFilters: ListFilterItem.getListFilterItems(props.appReportPage?.companyFilters, props.appReportPage?.userFilters),
            showListFilter: false,
            listFilterFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Permissions
            dataId: props.dataId,
            canCreateAppReports: props.appReportPage?.canCreateAppReports ?? false,
            // Settings
            showSettingsDialog: false,
            // Preview
            showDocumentPreview: false,
            // Trash Bin
            showTrashBinDialog: false,
        };
        this.state = {
            ...state,
            listFilterIsSet: this.getListFilterIsSet(state)
        };
        setAppReportListDefaultFilter(null);
    }

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
        this.props.onGetAppReportPage();
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: AppReportPageProp, prevState: IAppReportPageState): void {
        const props = this.props;
        const state = this.state;
        const equalCompanyIds = Base.equalStrArrays(prevProps.appReportPage?.companies.map(i => i.id) ?? [], props.appReportPage?.companies.map(i => i.id) ?? []);
        const prevCompanyId = prevProps.appReportPage && prevProps.appReportPage.companies.length > 0
            ? prevProps.appReportPage.companies[0].id
            : Base.emptyGuid;
        const companyId = props.appReportPage && props.appReportPage.companies.length > 0
            ? props.appReportPage.companies[0].id
            : Base.emptyGuid;
        const prevCanCreateAppReports = prevProps.appReportPage?.canCreateAppReports ?? false;
        const canCreateAppReports = props.appReportPage?.canCreateAppReports ?? false;
        const prevCanEditAllModuleProperties = prevProps.appReportPage?.canEditAllModuleProperties ?? false;
        const canEditAllModuleProperties = props.appReportPage?.canEditAllModuleProperties ?? false;
        const unitsData = props.appReportPage?.units ?? [];
        const equalUnits = IdTitleNode.equalIds(prevProps.appReportPage?.units ?? [], unitsData);
        const units = this.getUnits(unitsData);
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCanEditAllModuleProperties === canEditAllModuleProperties &&
            prevCanCreateAppReports === canCreateAppReports && equalCompanyIds && equalUnits
        ) {
            return;
        }
        const savedFilters = ListFilterItem.getListFilterItems(props.appReportPage?.companyFilters, props.appReportPage?.userFilters);
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            dataId: props.dataId,
            canCreateAppReports,
            initialized: !!props.appReportPage,
            activeCompanyId: companyId,
            units,
            selectedUnitIds,
            savedFilters,
            activeSavedFilterId,
            settingsActions: this.getSettingsActions(),
            showDocumentPreview: props.appReportPage?.showDocumentPreview ?? state.showDocumentPreview
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }
    
    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem, additionalGeneralFilter: any = null) => {
        const state = this.state;
        let result = {
            selectedUnitIds: state.selectedUnitIds,
            selectedStateIds: state.selectedStateIds,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            const filter = new ListFilterItem(listItemFilter);
            if (additionalGeneralFilter) {
                filter.generalFilter = { ...filter.generalFilter, ...additionalGeneralFilter };
            }
            result = ListFilterItem.getFilterProps(filter, result.sortColumn, result.sortOrderIsAsc, getFilterStateFromAppReportPageGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshPageData(companyId);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string, additionalGeneralFilter: any = null): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return {};
        const filterProps = this.getFilterPropsWithState(filter, additionalGeneralFilter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState),
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return {};
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState),
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Task);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showListFilter: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            listFilterFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, getAppReportPageGeneralFilterFromFilterState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.AppReport);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: getAppReportPageGeneralFilterFromFilterState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleShowListFilter = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showListFilter: true,
            listFilterFilter: filter
        });
    };

    handleListFilterPanelOk = (closeDialog: boolean, newFilterState: IAppReportPageFilterState): any => {
        const newState = {
            ...this.state,
            ...newFilterState
        };
        this.setState({
            showListFilter: !closeDialog,
            ...newFilterState,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
        return getAppReportPageGeneralFilterFromFilterState(newState);
    };
    
    handleFilterPanelCancel = () => {
        this.setState({ showListFilter: false });
    };
    // #endregion Record Filter

    // #region Units
    handleRefreshPageData = async (companyId: string) => {
        const pageData = await appReportService.getAppReportPageData(companyId);
        const state = this.state;
        //Units
        const units = this.getUnits(pageData.units);
        const selectedUnitIds = IdTitleNode.keepAvailableSelectedIds(units, state.selectedUnitIds);
        const stateChange = {
            activeCompanyId: companyId,
            units,
            selectedUnitIds,
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState),
        });
    };
    // #endregion Units

    handleShowDetailsPanel = (showDocumentPreview) => {
        this.setState({ showDocumentPreview });
        AppUtils.callService(() => userService.saveUserParameter(userParameterCodeShowDocumentPreview, showDocumentPreview ? "TRUE" : "FALSE"), false, true);
    };
        
    // #region Settings
    handleOpenSettingsDialog = () => {
        this.setState({
            showSettingsDialog: true
        });
    };
    
    handleSettingsDialogOk = async () => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        await this.handleRefreshPageData(this.state.activeCompanyId);
    };
    // #endregion Settings

    // #region Transh bin dialog
    handleOpenTrashBinDialog = () => {
        this.setState({
            showTrashBinDialog: true
        });
    };
    
    handleCloseTrashBinDialog = () => {
        this.setState({
            showTrashBinDialog: false,
            dataId: this.state.dataId + 1
        });
    };
    // #endregion Transh bin dialog

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.appReportPage ? props.appReportPage.companies : [];
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.Reports}
                    companies={companies}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar>
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    <PageListAndReportsContainer>
                        <AppReportList
                            filterName={state.activeSavedFilterId
                                ? state.savedFilters.find(i => i.id === state.activeSavedFilterId)?.title
                                : state.activeFilterId && state.activeFilterId !== Translations.Reports
                                    ? state.filters.find(i => i.id === state.activeFilterId)?.title
                                    : null}
                            sessionState={sessionState}
                            dataId={state.dataId.toString(10)}
                            addRecord={state.listAddRecord}
                            canCreateAppReports={state.canCreateAppReports}
                            listFilterIsSet={state.listFilterIsSet}
                            units={state.units}
                            selectedUnitIds={state.selectedUnitIds}
                            selectedStateIds={state.selectedStateIds}
                            companyId={state.activeCompanyId}
                            sortColumn={state.sortColumn}
                            sortOrderIsAsc={state.sortOrderIsAsc}
                            settingsActions={state.settingsActions}
                            thrashBin={false}
                            showDocumentPreview={state.showDocumentPreview}
                            onOpenFiltersDialog={this.handleShowListFilter}
                            onSetSortData={this.handleFilterSortData}
                            onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                            onOpenTrashBinDialog={this.handleOpenTrashBinDialog}
                            onChangeShowDocumentPreview={this.handleShowDetailsPanel}
                            onToggleSettingsDialog={this.handleOpenSettingsDialog}
                            reportTabs={(
                                <FilterTabs
                                    items={state.savedFilters}
                                    standardFilters={state.filters}
                                    selectedId={this.state.activeFilterId}
                                    selectedSavedId={this.state.activeSavedFilterId}
                                    onSetActiveItem={this.handleChangeActiveSavedFilter}
                                    onSetActiveStandardItem={this.handleChangeActiveFilter}
                                />
                            )}
                        />
                    </PageListAndReportsContainer>
                </PageContent>
                <AppReportPageFilterDrawer
                    open={state.showListFilter}
                    filter={state.listFilterFilter}
                    units={state.units}
                    states={state.states}
                    selectedUnitIds={state.selectedUnitIds}
                    selectedStateIds={state.selectedStateIds}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.handleListFilterPanelOk}
                    onCancel={this.handleFilterPanelCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.AppReport}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <AppReportSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        settingsActions={state.settingsActions}
                        onClose={this.handleSettingsDialogOk}
                    />
                }
                {state.showTrashBinDialog &&
                    <AppReportTrashBinDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        units={state.units}
                        onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                        onClose={this.handleCloseTrashBinDialog}
                    />
                }
            </PageContainer>
        );
    }
}